import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.DisqusProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/disqus_profile']
  id: 'disqus-profile'
